import type { AreaCatalog } from '../area';
import type { invite as en } from '../en/invite';

export const invite = {
  // --- An item invitation ---
  'invite.invalid.title': 'Einladung nicht verfügbar',
  'invite.invalid.body':
    'Dieser Einladungslink ist ungültig oder abgelaufen. Bitte die Person, die dich eingeladen hat, um einen neuen.',
  'invite.goHome': 'Zu Tesserano',
  'invite.invitedBy': '{name} hat dich eingeladen',
  'invite.signin.body':
    'Du wurdest eingeladen, in Tesserano mitzuarbeiten. Erstelle ein kostenloses Konto oder melde dich an, und öffne diesen Link dann noch einmal, um die Einladung anzunehmen.',
  'invite.createAccount': 'Konto erstellen',
  'invite.signIn': 'Anmelden',
  'invite.claimable.body':
    'Nimm die Einladung an, um an der Aufgabe mitzuwirken, zu der du eingeladen wurdest, samt allem darunter.',
  'invite.accept': 'Einladung annehmen',

  // --- An account link ---
  'invite.join.invalid.title': 'Link nicht verfügbar',
  'invite.join.invalid.body':
    'Dieser Link ist ungültig, aufgebraucht oder abgelaufen. Bitte die Person, die ihn geteilt hat, um einen neuen.',
  'invite.join.signin.bodyGroup':
    'Dieser Link erstellt dein Tesserano-Konto und nimmt dich in {group} auf.',
  'invite.join.signin.body': 'Dieser Link erstellt dein Tesserano-Konto.',
  'invite.join.haveAccount': 'Ich habe schon ein Konto',
  'invite.join.claimable.bodyGroup': 'Du bist angemeldet. Dieser Link nimmt dich in {group} auf.',
  'invite.join.claimable.body': 'Du bist angemeldet, und dieser Link hat dir nichts mehr zu geben.',
  'invite.join.createAccount': 'Konto erstellen',
  'invite.join.joinGroup': '{group} beitreten',
  'invite.join.continue': 'Weiter',
} as const satisfies AreaCatalog<typeof en>;
